import React, {Component} from 'react';
import {List} from 'antd';

import {Order} from '../../../../../../../../interfaces';

interface Properties {
  orderData: Order;
}

class Detail extends Component<Properties> {
  getListData(): JSX.Element[] {
    const {person, prospect, currentClub} = this.props.orderData.order;
    return [
      person.name || person.surname ? (
        <>
          <b>Name:</b>
          {person.name || ''} {person.surname || ''}
        </>
      ) : null,
      <>
        <b>Email:</b>
        {person.email || '-'}
      </>,
      <>
        <b>Phone:</b>
        {person.mobile ? person.mobilePrefix || '' : ''} {person.mobile || '-'}
      </>,
      <>
        <b>ID:</b>
        {person.nationalId || '-'}
      </>,
      <>&nbsp;</>,
      <>
        <b>Prospect ID:</b>
        {prospect.prospectId || '-'}
      </>,
      <>
        <b>Member ID:</b>
        {prospect.personExternalId || '-'}
      </>,
      <>&nbsp;</>,
      person.street ? (
        <>
          <b>Street:</b>
          {person.street || ''}
        </>
      ) : null,
      person.city ? (
        <>
          <b>City:</b>
          {person.city || ''} {person.postalCode || ''}
        </>
      ) : null,
      person.country ? (
        <>
          <b>Country:</b>
          {person.district || ''} {person.country || ''}
        </>
      ) : null,
      person.street || person.city || person.country ? <>&nbsp;</> : null,
      <>
        <b>Birth:</b>
        {person.dateOfBirth ? new Date(person.dateOfBirth).toLocaleDateString() : '-'}
      </>,
      <>
        <b>Citizien:</b>
        {person.isCitizen === true ? 'Yes' : person.isCitizen === false ? 'No' : '-'}
      </>,
      <>&nbsp;</>,
      <>
        <b>GDPR option:</b>
        {person.gdprOptin === true ? 'Yes' : person.gdprOptin === false ? 'No' : '-'}
      </>,
      <>&nbsp;</>,
      <>
        <b>Club:</b>
        {currentClub.name || '-'}
      </>,
    ].filter(a => !!a);
  }

  render(): JSX.Element {
    return (
      <>
        <h3 style={{marginBottom: 16, fontWeight: 600}}>Personal details</h3>
        <List size="small" bordered dataSource={this.getListData()} renderItem={(item: JSX.Element) => <List.Item>{item}</List.Item>} />
      </>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Personal/Personal.tsx